import { useApi } from "@nodus/api";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Page } from "@nodus/ui";
import { useAuth } from "../../auth/auth-context";
import { useOrg } from "../../app/shell-state";
import { Marketplace } from "../../features/marketplace/marketplace";

export const Route = createFileRoute("/_authed/$org/$project/reservedhosts/requests")({
  validateSearch: (search: Record<string, unknown>) => ({ request: search.request === true || search.request === "true" }),
  component: Requests,
});

function Requests() {
  const scope = Route.useParams();
  const { request } = Route.useSearch();
  const { org } = useOrg();
  const { client } = useApi();
  const { session } = useAuth();
  const navigate = useNavigate();
  const organization = { metadata: { name: org.name }, spec: { displayName: org.displayName } };
  return <Page><Marketplace key={org.name} consoleScope={scope} org={organization}
    me={{ role: org.role }} client={client} email={session?.user.email} view="Requests" requestOpen={request}
    onRequest={() => void navigate({ to: ".", search: { request: true } })}
    onViewChange={() => void navigate({ to: ".", search: { request: false }, replace: true })} /></Page>;
}
